export const localization = {
  pt: {
    at: 'às',
    by: 'Por',
    createCatalogButton: 'Criar catálogo',
    deleteCatalogAlert: {
      body: 'Ao excluir este catálogo, todos os arquivos anexados a ele serão removidos. Isso pode impactar o funcionamento dos Agentes de IA que utilizam essas referências.<br/><br/>Deseja excluir mesmo assim?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Excluir',
      },
      title: 'Excluir catálogo',
    },
    emptyState: {
      subtitle: 'Para começar, crie um catálogo para adicionar conteúdos',
      title: 'Ainda não há catálogos',
    },
    errorDeleteCatalogToast: {
      message: 'Não foi possível excluir o catálogo. Tente novamente.',
      title: 'Falha ao excluir catálogo',
    },
    headerContent: 'Base de conhecimento',
    searchPlaceholder: 'Pesquisar',
    subtitle: 'Gerencie a base de conhecimento para manter os agentes sempre atualizados com informações relevantes.',
    successDeleteCatalogToast: {
      message: 'O catálogo foi excluído da base de conhecimento.',
      title: 'Catálogo excluído',
    },
    tableHeaders: {
      catalog: 'Catálogo de conhecimento',
      content: 'Conteúdo',
      lastUpdate: 'Última atualização',
    },
    title: 'Gerenciar base de conhecimento',
  },
  en: {
    at: 'at',
    by: 'By',
    createCatalogButton: 'Create catalog',
    deleteCatalogAlert: {
      body: 'By deleting this catalog, all files attached to it will be removed. This may impact the operation of AI Agents that use these references.<br/><br/>Do you still want to delete it?',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      title: 'Delete catalog',
    },
    emptyState: {
      subtitle: 'To get started, create a catalog to add content',
      title: 'No catalogs yet',
    },
    errorDeleteCatalogToast: {
      message: 'Could not delete the catalog. Please try again.',
      title: 'Failed to delete catalog',
    },
    headerContent: 'Knowledge Base',
    searchPlaceholder: 'Search',
    subtitle: 'Manage the knowledge base to keep agents always up to date with relevant information.',
    successDeleteCatalogToast: {
      message: 'The catalog has been deleted from the knowledge base.',
      title: 'Catalog deleted',
    },
    tableHeaders: {
      catalog: 'Knowledge catalog',
      content: 'Content',
      lastUpdate: 'Last update',
    },
    title: 'Manage knowledge base',
  },
  es: {
    at: 'a las',
    by: 'Por',
    createCatalogButton: 'Crear catálogo',
    deleteCatalogAlert: {
      body: 'Al eliminar este catálogo, se eliminarán todos los archivos adjuntos a él. Esto puede afectar el funcionamiento de los Agentes de IA que utilizan estas referencias.<br/><br/>¿Desea eliminarlo de todos modos?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Eliminar',
      },
      title: 'Eliminar catálogo',
    },
    emptyState: {
      subtitle: 'Para comenzar, cree un catálogo para agregar contenido',
      title: 'Aún no hay catálogos',
    },
    errorDeleteCatalogToast: {
      message: 'No se pudo eliminar el catálogo. Inténtalo de nuevo.',
      title: 'Error al eliminar el catálogo',
    },
    headerContent: 'Base de conocimiento',
    searchPlaceholder: 'Buscar',
    subtitle:
      'Gestione la base de conocimiento para mantener a los agentes siempre actualizados con información relevante.',
    successDeleteCatalogToast: {
      message: 'El catálogo ha sido eliminado de la base de conocimiento.',
      title: 'Catálogo eliminado',
    },
    tableHeaders: {
      catalog: 'Catálogo de conocimiento',
      content: 'Contenido',
      lastUpdate: 'Última actualización',
    },
    title: 'Gestionar base de conocimiento',
  },
};
